import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
var getBgColorByType = function (type) {
    switch (type) {
        case 'action':
            return COLORS.ButtonAccent;
        case 'primary':
            return COLORS.ButtonPrimary;
        case 'secondary':
            return COLORS.ButtonSecondary;
        case 'white':
            return COLORS.ButtonWhite;
        case 'accent':
            return COLORS.ButtonAccent;
        case 'ghost':
            return COLORS.transparent;
    }
};
export default getBgColorByType;
